/**
 * Where savings stand against the corpus needed. "On track" when within
 * ON_TRACK_BAND of the corpus either way; otherwise a shortfall or a surplus.
 */
export const ON_TRACK_BAND = 0.02;

export type GapStatus = "shortfall" | "on-track" | "surplus";

export interface Gap {
  status: GapStatus;
  label: "Shortfall" | "On track" | "Surplus";
  /** Absolute size of the difference, in rupees. */
  amount: number;
  /** Savings divided by corpus. */
  coverage: number;
}

export function gapOf(corpus: number, savings: number): Gap {
  const diff = corpus - savings;
  const coverage = corpus > 0 ? savings / corpus : 0;
  if (corpus > 0 && Math.abs(diff) <= corpus * ON_TRACK_BAND) {
    return { status: "on-track", label: "On track", amount: Math.abs(diff), coverage };
  }
  return diff > 0
    ? { status: "shortfall", label: "Shortfall", amount: diff, coverage }
    : { status: "surplus", label: "Surplus", amount: -diff, coverage };
}
